import React from 'react';
export function Footer() {
  return <footer className="bg-mc-dark2 border-t border-mc-gray3 py-8 px-5 text-center" data-id="element-72">
      <div className="font-display text-[1.1rem] font-black mb-3" data-id="element-73">
        Mecánico<span className="text-mc-yellow" data-id="element-74">Check</span>
      </div>
      <p className="text-[0.78rem] text-mc-gray3 max-w-[640px] mx-auto leading-[1.6]" data-id="element-75">
        Este producto no reemplaza el diagnóstico de un profesional. Está
        diseñado para ayudarte a tomar mejores decisiones y entender mejor lo
        que te explican en el taller.
      </p>
      <p className="text-[0.75rem] text-mc-gray3 mt-4" data-id="element-76">
        © {new Date().getFullYear()} Mecánico Check — Todos los derechos
        reservados.
      </p>
    </footer>;
}